import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

const mock = [
  { id: '00000000-0000-0000-0000-000000000001', value: 'Вхідний' },
  { id: '00000000-0000-0000-0000-000000000002', value: 'Вихідний' },
];

const index = new AxiosMockAdapter(instance);

index
  .onGet(/\/api\/metering-node-locations\/?(?:\?.*)?$/)
  .reply(200, mock)
  .onAny()
  .passThrough();
